import { Typography } from "@deere/fuel-react";
import { Card, CardContent } from "@deere/fuel-react";
import _ from "lodash";
import AgricultureIcon from '@mui/icons-material/Agriculture';


const MachineDetails = (props) => {
    const { orderDetails } = props;
    const comar = _.concat(orderDetails.orderUnit, orderDetails.orderNumber);
    const invSrc = _.concat(orderDetails.inventorySrc," ", orderDetails.inventorySrcLoc);
    const soldToAccount = _.concat(orderDetails.orderUnit, orderDetails.soldToAccount);
    const status = _.concat(orderDetails.orderStatus, "-", orderDetails.machineStatus);
    const soldToAddress = _.concat(orderDetails.orderUnit, orderDetails.soldToAccount, ", ",orderDetails.accountName, " ", orderDetails.accountStreet, " ", orderDetails.accountZip, ", ", orderDetails.accountCity, ", ",orderDetails.accountCountry);

    return (
        <Card className="mt-3">
        <CardContent data-fuel-content-divider={"none"}>
                  <div className="h-[50px] mt-1 px-3 py-1 bg-white flex gap-2 justify-start items-start">
          <div><AgricultureIcon /></div>
          <b className="text-xl">Comar: <span>{comar}</span></b>
          <div>
            <Typography style={{marginLeft: '10px'}} variant={"h2"} component={"h2"} fontWeight={"2000"} fontStyle={{color: 'grey'}}>
              {"Serial:"} <span>{orderDetails.serial17}</span>
            </Typography>
          </div>
          {/* <div>Badge</div> */}
        </div>
        <div className="flex flex-col gap-3">
          <div className="flex">
            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Inventory Source
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {invSrc}
              </Typography>
            </div>
            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Product
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {orderDetails.product}
              </Typography>
            </div>
          </div>
          <div className="flex">
          <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Credit Code
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {orderDetails.creditCode}
              </Typography>
            </div>
            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Order Status
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {status}
              </Typography>
            </div>
          </div>
          <div className="flex">
            <div className="flex flex-col gap-1 w-[300px]">
              <Typography fontWeight={"700"} fontSize={14}>
                Sold to 
              </Typography>
              <Typography fontWeight="400" fontSize={16}>
                {soldToAddress}
              </Typography>
            </div>
          </div>
        </div>
      </CardContent>
      </Card>
    );
};

export default MachineDetails;